"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamQuoteProperty = exports.teamQuotePropertyDefinition = void 0;
exports.teamQuotePropertyDefinition = {
    view: {
        label: 'Team Quote',
        style: 'blockquote',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'team-quote-text',
                'team-quote-author',
                'team-quote-link',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'team-quote',
};
const isTeamQuoteProperty = (prop) => {
    return prop.name === exports.teamQuotePropertyDefinition.name;
};
exports.isTeamQuoteProperty = isTeamQuoteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS1xdW90ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RlYW0tcXVvdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBS2EsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsWUFBWTtRQUNuQixLQUFLLEVBQUUsWUFBWTtLQUNwQjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1IsaUJBQWlCO2dCQUNqQixtQkFBbUI7Z0JBQ25CLGlCQUFpQjthQUNsQjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBTTFCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxJQUFrQixFQUE2QixFQUFFO0lBQ25GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CIn0=